import { render } from "./list_no_charge.vue?vue&type=template&id=3a5163c3"
import script from "./list_no_charge.vue?vue&type=script&lang=js"
export * from "./list_no_charge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__